const webpackContext = require.context("./modules/", true, /\.js$/);

let apis = {};
webpackContext.keys().map((item) => {
  const defaultModule = webpackContext(item).default;
  apis = Object.assign(apis, defaultModule);
});

export default apis;
